import FeaturesService from '@justeat/f-feature-management';

export default (context, inject) => {
    const {
        store, $axios, $gtm, $log, $cookies
    } = context;

    const { featureManagement } = store.state.configuration.settings;

    if (featureManagement.isEnabled) {
        const service = new FeaturesService(store, {
            httpClient: $axios,
            cookies: $cookies,
            analytics: $gtm,
            log: $log
        });

        service.update();

        inject('features', service.plugin);

        return;
    }

    inject('features', {
        getBooleanValue () {
            return null;
        },
        getValue () {
            return null;
        }
    });
};
